import request from '../../utils/request'

// 主体数据
export function body () {
  return request.get('/business/staging/body')
}

// 头部数据
export function head () {
  return request.get('/business/staging/head')
}

// 主体数据
export function timeoutPage (data) {
  return request.post('/business/staging/timeoutPage', data)
}

// 超时预警人员离场
export function level (visitId) {
  return request.get(`/business/staging/level?visitId=${visitId}`)
}
